import { render } from "./Event.view.vue?vue&type=template&id=0a046da2"
import script from "./Event.view.vue?vue&type=script&lang=js"
export * from "./Event.view.vue?vue&type=script&lang=js"

import "./Event.view.vue?vue&type=style&index=0&id=0a046da2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__